/**
 * ExecutiveSafetyPage - Executive-level safety reporting
 *
 * Surfaces the ExecutiveSafetyDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides C-level safety metrics, incident trends, and compliance status.
 *
 * Life-critical: This dashboard aggregates T3 QAPI-protected safety data.
 *
 * Route: /admin/executive-safety
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons-react';

import { ExecutiveSafetyDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ExecutiveSafetyPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="red">
            <IconShieldCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Executive Safety Dashboard</Title>
            <Text size="sm" c="dimmed">
              C-level safety metrics, incident trends, and compliance posture
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ExecutiveSafetyDashboard />
    </Container>
  );
}

export default ExecutiveSafetyPage;
